import {
  CssCustomProperties,
  CssProperties,
} from '@wix/component-protocol/schema';

import { PlatformPrivateServices } from '../../../PlatformPrivateServices';

import type { ColorPickerOptions } from '@wix/public-editor-platform-interfaces';

export type ISelectColorParams =
  | {
      styleItemKey: string;
    }
  | ColorPickerOptions;

const COLOR_PROPERTIES = [
  'backgroundColor',
  'border',
  'borderColor',
  'borderTopColor',
  'borderBottomColor',
  'borderLeftColor',
  'borderRightColor',
  'borderInlineStartColor',
  'borderInlineEndColor',
  'color',
  'textShadow',
  'textDecorationColor',
  'boxShadow',
];

export class HostColorSelectorAPI {
  static isColorProperty = (property?: string) => {
    return property ? COLOR_PROPERTIES.includes(property) : false;
  };

  constructor(private ps: PlatformPrivateServices) {}

  selectColor(
    styleItemKey: string,
    context: {
      styleDefinitions?: {
        cssProperties?: CssProperties;
        cssCustomProperties?: CssCustomProperties;
      };
      styles?: {
        cssProperties?: Record<string, string>;
        cssCustomProperties?: Record<string, string>;
      };
      onChange: (color: string) => void;
    },
  ) {
    const propertyType = context.styleDefinitions?.cssProperties?.[styleItemKey]
      ? styleItemKey
      : context.styleDefinitions?.cssCustomProperties?.[styleItemKey]
          .cssPropertyType;

    if (!HostColorSelectorAPI.isColorProperty(propertyType)) {
      // TODO: throw error: unsupported property type https://wix.atlassian.net/browse/EP-6428
    }

    // feels bad
    const initialValue =
      context.styles?.cssProperties?.[styleItemKey] ??
      context.styles?.cssCustomProperties?.[styleItemKey];

    return new Promise<string | undefined>((resolve) => {
      let value: string | undefined = initialValue;

      const onChange = (color: string) => {
        context.onChange(color);
        value = color;
      };

      const onApply = async (color: string) => {
        resolve(color);
      };

      void this.ps.hostAPI.editor.selectColor({
        initialValue,
        onApply,
        onChange,
        onClose: () => {
          resolve(value);
        },
        onCancel: () => {
          resolve(initialValue);
        },
        showBrand: true,
        showCustom: true,
        mode: ['solid'],
      });
    });
  }
}
